import { render, staticRenderFns } from "./Developers.vue?vue&type=template&id=f0ea1e18&scoped=true"
import script from "./Developers.vue?vue&type=script&lang=js"
export * from "./Developers.vue?vue&type=script&lang=js"
import style0 from "./Developers.vue?vue&type=style&index=0&id=f0ea1e18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ea1e18",
  null
  
)

export default component.exports